import React from "react";
import { IFilterValueSelectorProps } from "./interfaces";
import _ from "lodash";
import AccountSearchAutocomplete from "../AccountSearchAutocomplete/AccountSearchAutocomplete";
import { useGetAllAccounts } from "../../../services/react-query/accounts";

export default function AccountFilterSelector({ filterValues, setFilterValues }: IFilterValueSelectorProps) {
  const filteredUuids = _.compact(filterValues);

  const { data: accounts } = useGetAllAccounts({
    params: {
      filters: {
        uuid: filteredUuids
      },
      per_page: 0,
    },
    enabled: !_.isEmpty(filteredUuids),
  });

  return <AccountSearchAutocomplete
    isMultiple
    value={_.filter(accounts?.data, account => _.includes(filterValues, account.uuid))}
    onChange={(accounts) => setFilterValues(_.map(accounts, 'uuid'))}
  />;
}
